import { render, staticRenderFns } from "./segmentosConfiguracoes.vue?vue&type=template&id=a842ad28&scoped=true&"
import script from "./segmentosConfiguracoes.vue?vue&type=script&lang=js&"
export * from "./segmentosConfiguracoes.vue?vue&type=script&lang=js&"
import style0 from "./segmentosConfiguracoes.vue?vue&type=style&index=0&id=a842ad28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a842ad28",
  null
  
)

export default component.exports